<app-page-loader *ngIf="pageLoader$ | async"></app-page-loader>
<router-outlet></router-outlet>


